import i18n from '../../i18n/index'
import ReportSerivce from '../../services/report-audit-add/ReportSerivce';
import serviceOrder from '../../services/orders/OrderService';
import moment from 'moment-timezone';
// import ApiService from '../../services/ApiService'
// import XLSX from 'xlsx'
import JsonExcel from 'vue-json-excel';

export default {
    components: {
        JsonExcel
    },
    data: () => ({
        excelFileName: 'data.xlsx',
        loading: false,
        loadingp: false,
        itemsDatafarma: [],
        nroRowsfarma: 0,
        Notstatus: 0,
        dispatch: 0,
        headers_farma: [{
                text: "id",
                sortable: false,
                value: "id",
            },
            {
                text: "creationDate",
                sortable: false,
                value: "creationDate",
            },
            // {
            //     text: "message",
            //     sortable: false,
            //     value: "message",
            // },
            {
                text: "processed",
                sortable: false,
                value: "processed",
            },
            {
                text: "processing",
                sortable: false,
                value: "processing",
            },
            {
                text: "idOrder",
                sortable: false,
                value: "idOrder",
            },
            {
                text: "idSura",
                sortable: false,
                value: "idSura",
            },
        ],
        itemsDatauth: [],
        nroRowsauth: 0,
        headers_auth: [{
                text: "id",
                sortable: false,
                value: "id",
            },
            {
                text: "creationDate",
                sortable: false,
                value: "creationDate",
            },
            {
                text: "identificationType",
                sortable: false,
                value: "identificationType",
            },
            {
                text: "identification",
                sortable: false,
                value: "identification",
            },
            {
                text: "orderNumber",
                sortable: false,
                value: "orderNumber",
            },
            {
                text: "status",
                sortable: false,
                value: "status",
            },
            // {
            //     text: "payload",
            //     sortable: false,
            //     value: "payload",
            // },
        ],
        searchtypeId: ['CC', 'TI', 'PA', 'RC'],
        searchtypeStatus: ['N', 'A', 'P', 'E'],
        itemsDataUser: [],
        nroRowsUSer: 0,
        headers_user: [{
                text: "id",
                sortable: false,
                value: "id",
            },
            {
                text: "creationDate",
                sortable: false,
                value: "creationDate",
            },
            {
                text: "identificationType",
                sortable: false,
                value: "identificationType",
            },
            {
                text: "identification",
                sortable: false,
                value: "identification",
            },
            {
                text: "orderNumber",
                sortable: false,
                value: "orderNumber",
            },
            {
                text: "status",
                sortable: false,
                value: "status",
            },
            {
                text: "payload",
                sortable: false,
                value: "payload",
            },
        ],
        typeId: null,
        identification: null,
        typeStatus: null
    }),
    created() {},
    computed: {
        // Define el objeto fields con títulos de columnas
        excelFields() {
            return [
                { key: 'id', label: 'ID' },
                { key: 'creationDate', label: 'Fecha de Creación' },
                { key: 'identificationType', label: 'Tipo de Identificación' },
                { key: 'identification', label: 'Identificación' },
                { key: 'orderNumber', label: 'Número de Orden' },
                { key: 'status', label: 'Estado' },
                { key: 'payload', label: 'Datos' },
            ];
        },
        // Define el objeto header con títulos de columnas para el archivo Excel
        excelHeader() {
            return {
                id: 'ID',
                creationDate: 'Fecha de Creación',
                identificationType: 'Tipo de Identificación',
                identification: 'Identificación',
                orderNumber: 'Número de Orden',
                status: 'Estado',
                payload: 'Datos',
            };
        },
    },
    watch: {},
    methods: {
        async ordersfarmadomicilios() {
            this.loading = true;
            ReportSerivce.ordersfarmadomicilios().then((response) => {
                this.itemsDatafarma = response.data;
                this.nroRowsfarma = response.data.length;
                this.loading = false;
            });
        },
        async authorizations() {
            this.loading = true;
            ReportSerivce.authorizations().then((response) => {
                this.itemsDatauth = response.data;
                this.nroRowsauth = response.data.length;
                this.loading = false;
            });
        },
        async dispatchOrders() {
            this.loading = true;
            ReportSerivce.dispatchOrders().then((response) => {
                this.dispatch = response.data[0].despachos;
                this.loading = false;
            });
        },
        async LogStatusChangeOrders() {
            this.loading = true;
            ReportSerivce.LogStatusChangeOrders().then((response) => {

                this.Notstatus = response.data[0].notificaciones;
                console.log("🚀 ~ ReportSerivce.LogStatusChangeOrders ~ response.data:", this.Notstatus)
                this.loading = false;
            });
        },
        async AuthUser() {
            this.loading = true;
            console.log(this.typeId)
            console.log(this.identification)
            console.log(this.typeStatus)
            const typeId = this.typeId;
            const identification = this.identification;
            const typeStatus = this.typeStatus;

            await serviceOrder.Auth_user(typeId, identification, typeStatus).then((response) => {
                console.log("rewpsuesta >>>", response.data);
                this.itemsDataUser = response.data;
                this.nroRowsUSer = response.data.length;
                this.loading = false;
            });
        },
        formatFechaColombia(fechaOriginal) {
            const fechaMomentUtc = moment.utc(fechaOriginal);
            const fechaMomentColombia = fechaMomentUtc.tz('America/Bogota');
            return fechaMomentColombia.format('YYYY-MM-DD HH:mm:ss');
        },
    }
}